import React,{useState} from "react";
import "./OrderConfirmation.scss";
import {MDBIcon} from "mdbreact";
import {compose} from "redux";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {Zoom} from "react-reveal";
import {assetUrl} from "../../serviceApi";
import {numberFormat} from "../../util";

const PaymentFailedIcon = assetUrl+"images/payment-failed-icon.png";
const ProfileIcon = assetUrl+"images/profile-icon.svg";
const GiftPaper = assetUrl+'images/gift-paper1.png'
const TickWithGreenBg = assetUrl+"images/tick-with-green-bg.svg";
const Close =  assetUrl+'images/wrong_image.svg'
const insufficientIllustration = assetUrl+'images/Illustration_Insufficient balance.png'


function OrderConfirmation(props){
    const {quantity,completed_action,order_failed,stock_data,submit,limit_order_price,order_mode,wallet_data,addMoney} = props;
    const [confettiFired, setConfettiFired] = useState("notFired");

    if(!order_failed && confettiFired==="notFired"){
        setTimeout(()=>{
            setConfettiFired("fire")
        },1000)
        setTimeout(()=>{
            setConfettiFired("stop")

        },2000)
    }

    return(
        <div className={"order-confirmation-component"}>
            <div>
	            <img src={Close} alt={"alt"} className={"close-icon"} onClick={props.closeModal}/>
                { stock_data.price * quantity > wallet_data.balance ?
	                <div className={"insufficient-balance-section text-center"}>
		                <img src={insufficientIllustration} alt={"alt"} className={"insufficient-illustration mb-3"}/>
		                <p className={"main-text mb-3"}>Insufficient Balance!</p>
		                <p className={"sub-text mb-3"}>Please add funds to your wallet to place the order.</p>
		                <button className={"button mt-3"} onClick={()=>addMoney("add_money")}>
			                Add Money
			                <MDBIcon icon="angle-right" className={"ml-2"} />
		                </button>
	                </div>:
                    order_failed === true ?
                        <div className={"order-failed-section text-center"}>
                            <img src={PaymentFailedIcon} alt={"PaymentFailedIcon"} className={"img-fluid my-3"}/>
                            <p className={"shared-title "}>Payment Failed</p>
                            <p className={"shared-description "}>Your transaction has failed due to some technical error. Please try again later.</p>
                            <button type={"button"} className={"btn retry-btn"} onClick={submit}>
                                Retry
                                <MDBIcon icon="angle-right" className={"ml-2"} />
                            </button>
                        </div>
                        :
                        <div id={"orderSuccess"}>

                            <div className={"gift-content-section"}>
                                <img src={stock_data.politicianImage ? stock_data.politicianImage :ProfileIcon} alt={"StockProfile"} className={"img-fluid stock-profile"}/>
                                {
                                    confettiFired==="fire"?
                                        <div className={"gift-paper"}>
                                            <Zoom duration={"1000"} >
                                                <img src={GiftPaper} alt={"GiftPaper"} />
                                            </Zoom>
                                        </div>

                                        :
                                        confettiFired==="stop"?
                                            <div className={"gift-paper animate__animated animate__fadeOut"}>
                                                <img src={GiftPaper} alt={"GiftPaper"} />
                                            </div>:null
                                }


                                <img src={TickWithGreenBg} alt={"TickWithGreenBg"} className={"img-fluid green-tick"}/>
                            </div>
                            {
                                order_mode === "Limit_Order" ? 
                                <div className={"text-center mb-5"}>
                                    <p className={"shared-title "}> {completed_action==="SELL"?"Sale":"Purchase"}has been Executed!</p>
                                    <p className={"shared-description "}>You Sold {parseFloat(quantity)} Share{parseFloat(quantity)>1?"s":""} of {stock_data.name} for {numberFormat((parseFloat(quantity) * parseFloat(limit_order_price)).toFixed(2))} per share.</p>
                                </div>:
                                <div className={"text-center mb-5"}>
                                    <p className={"shared-title "}> {completed_action==="SELL"?"Sale":"Purchase"} has been Executed!</p>
                                    <p className={"shared-description "}>You {completed_action==="SELL"?"Sold":"Bought"} {parseFloat(quantity)} Share{parseFloat(quantity)>1?"s":""} of {stock_data.name} for {numberFormat((parseFloat(quantity) * parseFloat(stock_data.price)).toFixed(2))} per share.</p>
                                </div>
                            }
                            
                        </div>
                }
            </div>

        </div>
    );
}


const mapStateToProps = state => ({
    user_details: state.UserReducer.user_details
});
export default compose(
    withRouter,
    connect(mapStateToProps)
)(OrderConfirmation)


